
import React, {useContext} from "react"

// providers and contexts
import {ScrollProvider, CatalogueContext} from "../../../context"

// components
import List from "../Catalogue/Search/List"

// the component
function Select() {
  // contexts
  let catalogue = useContext(CatalogueContext)

  if(catalogue.isReady) {
    return (
      <div id="s-buddy-select">
        <h1>Buddy Select</h1>
        <ScrollProvider>
          <List />
        </ScrollProvider>
      </div>
    )
  }
  else {
    // TODO implement somethings
    return <div>catalogue NOT ready</div>
  }
  /*
  return (
    <div id="s-buddy-select">
      <h1>Buddy Select</h1>
      <List />
    </div>
  )
  */
}

export default Select
/*
// context
import {CatalogueContext} from "../../../context"

// components
import Filter from "../../views/Catalogue/Search/Filter"
import List from "../../views/Catalogue/Search/List"

// the component
const Search = () => {
  // contexts
  let catalogue = useContext(CatalogueContext)

  // render
  return(
    <>
      <List />
      {catalogue.isReady ? <Filter /> : null}
    </>
  )
}

export default Search

*/